import {useMutation} from "@apollo/client";

import {FormModal} from "@/components/form/overlay/FormModal.tsx";
import {GQL_STATUS_PAGE_QUERY} from "@/lib/queries/statuspages.ts";
import {
  GQL_EXTERNAL_USER_UPDATE,
  GQL_EXTERNAL_USERS,
  UpdateExternalUserResponse,
} from "@/lib/queries/statuspagesExternalUsers.ts";
import {ResponseStatus} from "@/lib/types/common.ts";
import {AddExternalUserForm} from "@/pages/statuspages/tabs/external-users/components/AddExternalUserForm.tsx";

interface AddExternalUserModalProps {
  setShow: (show: boolean) => void;
  statusPageID: number;
}

export interface UpdateExternalUserFormValues {
  first_name: string;
  last_name: string;
  email: string;
}

export const AddExternalUserModal = ({statusPageID, setShow}: AddExternalUserModalProps) => {
  const [updateExternalUser, {data, loading}] = useMutation<UpdateExternalUserResponse>(GQL_EXTERNAL_USER_UPDATE, {
    refetchQueries: [GQL_STATUS_PAGE_QUERY, GQL_EXTERNAL_USERS],
    context: {
      noToast: true,
    },
  });
  const formId = "newExternalUser";

  const onSubmit = async (values: UpdateExternalUserFormValues) => {
    const resp = await updateExternalUser({
      variables: {
        statusPageID: statusPageID,
        data: values,
      },
    });

    setShow(resp?.data?.response?.status !== ResponseStatus.SUCCESS);
  };
  return (
    <FormModal
      disabled={loading}
      formId={formId}
      hasRequiredFields
      onCancel={() => setShow(false)}
      show={true}
      title="Add External Account User"
      submitBtnText="Add External User"
    >
      <AddExternalUserForm
        formId={formId}
        onSubmit={onSubmit}
        onError={console.error}
        serverErrors={data?.response?.message}
      />
    </FormModal>
  );
};
